import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { LoadStatus } from '../../load-status';
import {
    DATE_MANIPULATION_CHECK_FEATURE_KEY,
    DateManipulationCheckState,
    PersistedTimestamps,
    TimestampCheckResult,
} from '../date-manipulation-check-collection.state';

export const selectDateManipulationCheckState = createFeatureSelector<DateManipulationCheckState>(
    DATE_MANIPULATION_CHECK_FEATURE_KEY,
);

export const selectDateManipulationCheckInitialized: MemoizedSelector<object, boolean> = createSelector(
    selectDateManipulationCheckState,
    (state) => state.initialized,
);

export const selectDateManipulationCheckLoadStatus: MemoizedSelector<object, LoadStatus> = createSelector(
    selectDateManipulationCheckState,
    (state) => state.loadStatus,
);

export const selectDateManipulationCheckLoaded: MemoizedSelector<object, boolean> = createSelector(
    selectDateManipulationCheckState,
    (state) => state.loadStatus === LoadStatus.Loaded,
);

export const selectLastTimestampCheckValid: MemoizedSelector<object, boolean> = createSelector(
    selectDateManipulationCheckState,
    (state) => state.lastCheck.valid,
);

/**
 * The full result of the last validity check, combined into one selector so the reporting
 * effects (`reportCheck$`, `appLock$`) read it with a single `concatLatestFrom` rather than one
 * per field.
 */
export const selectLastTimestampCheck: MemoizedSelector<object, TimestampCheckResult> = createSelector(
    selectDateManipulationCheckState,
    (state) => state.lastCheck,
);

/**
 * Projects the slice to the two fields that survive a restart — the `PERSISTED_SLICES`
 * projection used by the generic persistence layer.
 */
export const selectPersistedDateManipulationCheckTimestamps: MemoizedSelector<object, PersistedTimestamps> =
    createSelector(selectDateManipulationCheckState, (state) => ({
        lastValidInternalTimestamp: state.lastValidInternalTimestamp,
        lastValidExternalTimestamp: state.lastValidExternalTimestamp,
    }));
